export default function Footer() {
    return (
        <div className="mt-10" style={{background: '#141728'}}>
            <div className="flex justify-end max-w-7xl mx-auto px-4 py-5 sm:px-6 lg:px-8">
                <b className="mr-2">Joshua</b>
                <span>Opata</span>
                <span className="w-5"></span>
                <span>&#169;</span>
                <span>2021. All Rights Reserved</span>
            </div>
        </div>
    )
}